import { render, staticRenderFns } from "./MessageContentUserLocation.vue?vue&type=template&id=652cef1c"
import script from "./MessageContentUserLocation.vue?vue&type=script&lang=js"
export * from "./MessageContentUserLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports